import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: `flex flex-row justify-end'} w-full` }
const _hoisted_2 = { class: "flex flex-row mb-6 z-20" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"float-left pl-18 pr-4 w-32\"></div><div class=\"items-center w-36\"><div class=\"text-12px xxl:text-14px text-gray-lp-300\">Total Tarif</div><div class=\"text-20px text-red-lp-100 font-bold\"> IDR - </div></div><div class=\"float-right pt-6 pl-4\"></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_receipt_language = _resolveComponent("select-receipt-language")!
  const _component_Book = _resolveComponent("Book")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isProductInterpack)
        ? (_openBlock(), _createBlock(_component_select_receipt_language, {
            key: 0,
            class: "pr-4"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Book, {
        bookingType: _ctx.bookingType,
        payload: _ctx.payload,
        isDisabled: _ctx.isDisabled
      }, null, 8, ["bookingType", "payload", "isDisabled"])
    ])
  ]))
}